var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ai-selected-tag"},[_vm._v(_vm._s(_vm.$t('questionnaire.aiTag')))])
}
var staticRenderFns = []

export { render, staticRenderFns }